import { createContext, useState } from 'react'

interface snackbarObject {
  severity: 'error' | 'warning' | 'info' | 'success'
  message: string
  autoHideDuration?: number
}

interface snackbarHelperContextInterface {
  snackbarSettings: snackbarObject | null
  setSnackbarSettings: (settings: snackbarObject | null) => void
}

export const SnackbarHelperContext = createContext<snackbarHelperContextInterface>(
  {} as snackbarHelperContextInterface
)

export function SnackbarHelper({ children }: any) {
  const [snackbarSettings, setSnackbarSettings] = useState<snackbarObject | null>(null)

  return (
    <SnackbarHelperContext.Provider
      value={{
        snackbarSettings: snackbarSettings,
        setSnackbarSettings: setSnackbarSettings,
      }}
    >
      {children}
    </SnackbarHelperContext.Provider>
  )
}
